/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { SelectMenuItem, Text, Theme, useTheme } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { Fragment } from 'react'

interface CboCuidadoCompartilhadoGrupoHeaderProps {
  itemProps: any
  isGrupoCboVinculado: boolean
  hasCboVinculados: boolean
  hasCboNaoVinculados: boolean
}

export function CboCuidadoCompartilhadoRenderGrupoHeader(props: CboCuidadoCompartilhadoGrupoHeaderProps) {
  const { itemProps, isGrupoCboVinculado, hasCboVinculados, hasCboNaoVinculados } = props

  const theme = useTheme()
  const styles = createStyles(theme)
  const { NOVA_ABA_ENCAMINHAMENTO_ENABLED } = useFlags()

  const emptyGroupMessage =
    ((isGrupoCboVinculado && !hasCboVinculados) || (!isGrupoCboVinculado && !hasCboNaoVinculados)) &&
    'Nenhum CBO disponível.'

  const labelComFlag = isGrupoCboVinculado ? 'Vinculadas' : 'Não vinculadas'
  const labelSemFlag = isGrupoCboVinculado
    ? "CBO's vinculadas - via compartilhamento de cuidado"
    : "Sem CBO's vinculadas - via guia de encaminhamento"

  const labelCbo = NOVA_ABA_ENCAMINHAMENTO_ENABLED ? labelComFlag : labelSemFlag

  return (
    <Fragment>
      <SelectMenuItem style={styles.headerItem} {...itemProps}>
        <Text fontWeight='bold' style={styles.headerItemText}>
          {labelCbo}
        </Text>
      </SelectMenuItem>
      {emptyGroupMessage && (
        <SelectMenuItem style={styles.disabledItem} {...itemProps}>
          <Text>{emptyGroupMessage}</Text>
        </SelectMenuItem>
      )}
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  headerItem: css`
    pointer-events: none;
    cursor: not-allowed;
    background-color: ${theme.pallete.primary.c90};
  `,
  headerItemText: css`
    color: ${theme.pallete.primary.c40};
  `,
  disabledItem: css`
    pointer-events: none;
    cursor: not-allowed;
  `,
})
